import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';
import {registerAllModules} from 'handsontable/registry';

import {AppModule} from './app/app.module';
import {environment} from './environments/environment';

registerAllModules();

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
